"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTypeEnum = void 0;
var AccessTypeEnum;
(function (AccessTypeEnum) {
    AccessTypeEnum[AccessTypeEnum["Manager"] = 80] = "Manager";
    AccessTypeEnum[AccessTypeEnum["Driver"] = 81] = "Driver";
    AccessTypeEnum[AccessTypeEnum["Tester"] = 82] = "Tester";
    AccessTypeEnum[AccessTypeEnum["UsersControl"] = 100] = "UsersControl";
    AccessTypeEnum[AccessTypeEnum["VehicleControl"] = 101] = "VehicleControl";
    AccessTypeEnum[AccessTypeEnum["CompanyControl"] = 102] = "CompanyControl";
    AccessTypeEnum[AccessTypeEnum["DriverControl"] = 103] = "DriverControl";
    AccessTypeEnum[AccessTypeEnum["RateControl"] = 104] = "RateControl";
    AccessTypeEnum[AccessTypeEnum["ActiveControl"] = 105] = "ActiveControl";
    AccessTypeEnum[AccessTypeEnum["SuperAdmin"] = 255] = "SuperAdmin";
})(AccessTypeEnum || (exports.AccessTypeEnum = AccessTypeEnum = {}));
//# sourceMappingURL=AccessTypeEnum.js.map